import React, { createContext, useState, useContext, ReactNode } from 'react';
import { LayoutProps, ILayoutSection } from './_types';
import { has } from 'mobx';
import { hasPath } from 'ramda';

type LayoutContextType = {
  layouts: LayoutProps[];
  setCurrentLayoutId: (id: string) => void;
  getSectionById: (layoutId:string,id: string) => ILayoutSection | undefined;
};

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

interface LayoutProviderProps {
  children: ReactNode;
  initialLayouts: LayoutProps[];
}

const LayoutProvider: React.FC<LayoutProviderProps> = ({ children, initialLayouts }) => {
  const [layouts] = useState<LayoutProps[]>(initialLayouts);


  const getSectionById = (layoutId:string,id: string): ILayoutSection | undefined => {
    const currentLayout = layouts.find((layout) => layout.id === layoutId);
    const section = hasPath(["props","sections",id],currentLayout) ? (currentLayout as any)?.props?.sections[id] : undefined;
    return section;
  };

  return (
    <LayoutContext.Provider value={{ layouts, setCurrentLayoutId:(id:string) => {}, getSectionById }}>
      {children}
    </LayoutContext.Provider>
  );
};

const useLayout = (): LayoutContextType => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
export const useLayoutFrom = (id: string) => {
 useLayout().setCurrentLayoutId(id);
};

export { LayoutProvider, useLayout };
